import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const prod: IPartnerAppSettings = {
  cdnBaseUrl: '',
  serviceEndPoints: [
    {
      clientId: '6db56845-5ebb-4b74-88d0-28cc0e41e163',
      serviceEndPoint: 'https://professionalservices.microsoft.com/dm/'
    },
    {
      clientId: '6db0b12a-edd4-4521-8406-a615ce8659d6',
      serviceEndPoint: 'https://oneprofileprodapipack.azurefd.net/api/v1/'
    },
    {
      clientId: '6db0b12a-edd4-4521-8406-a615ce8659d6',
      serviceEndPoint: 'https://oneprofileprodapipack.azurefd.net/api/v2.0/'
    },
    {
      clientId: 'e42b0f1c-114a-42a1-853a-089f1ab22b22',
      serviceEndPoint: 'https://fd-rmxcsvc-prod-hea9ftfragehe3b9.b02.azurefd.net/'
    },
    {
      clientId: '00000003-0000-0000-c000-000000000000',
      serviceEndPoint: 'https://graph.microsoft.com/'
    },
    {
      clientId: '2a5ea82d-af4c-494d-9d60-79db20d2ebd1',
      serviceEndPoint: 'https://professionalservices.microsoft.com/csp-api/'
    },
    {
      clientId: 'f7470a18-ff38-48f9-a999-9eed10bbaac4',
      serviceEndPoint: 'https://tubfactory-api-prod-hkhcf6fseggneyf0.westus-01.azurewebsites.net/'
    }
  ],
  ReactDmAppConfiguration: {
    apimSubscriptionKey: '90f2495ce4c44a1594ddbb0715ac6107',
    cspSubscriptionKey: '6ce775478d60402492136312fa60ccc8',
    dmServiceBaseUri: 'https://professionalservices.microsoft.com/dm/',
    cspBaseUrl: 'https://professionalservices.microsoft.com/csp-api/',
    oneProfileBaseUrl: 'https://oneprofileprodapipack.azurefd.net/',
    oneProfileGraphQlBaseUrl: 'https://prod.apis.profileskills.microsoft.com/',
    oneProfileGraphQLPageSize: 1000,
    esxpBaseUrl: 'https://esxp.microsoft.com/#/',
    rmexBaseUrl: 'https://fd-rmxcsvc-prod-hea9ftfragehe3b9.b02.azurefd.net/',
    rmexCustomersBaseUrl: 'https://professionalservices.microsoft.com/rm-customers-api/api/v1.0/',
    rmexCustomersSubscriptionKey: '1dde0863045642c59820b2462fe1b2e4',
    msxOpportunityUrl: 'https://microsoftsales.crm.dynamics.com/main.aspx?etn=opportunity&pagetype=entityrecord&id=%s',
    roleIds: '28,159,163,187,59,102',
    managerRoleIds: '160,189', // CSAM Manager (Business Role ID = 189), CSA Manager (Business Role ID = 160)
    graphBaseApi: 'https://graph.microsoft.com/v1.0/',
    tubServiceBaseUri: 'https://tubfactory-api-prod-hkhcf6fseggneyf0.westus-01.azurewebsites.net/',
    ocvFeedbackIsProduction: true
  }
};
